// Runtime-accessor fallback: rolldown's automatic chunking can fold a module's compiled bytes into
// ANY chunk that ends up needing them — including a chunk the module is never a manually LISTED
// member of (scripts/delta/app-shared-modules.json's `VERSION_BEARING` exclusion class only sees
// modules entryModules() reports as living in entry/App; it is structurally blind to this
// satellite-absorption class — see that file's VERSION_BEARING comment). The fix is this module: it
// must NEVER reference the raw version define directly (that would just re-bake the version literal
// into wherever THIS module's own bytes end up instead, defeating the whole point) — it reads a
// global only the always-changed entry chunk (src/index.tsx) seeds, so whatever chunk absorbs this
// module's tiny, version-INDEPENDENT bytes never re-couples to a release bump.
declare global {
  // Fenced with `__` on purpose: the bare name would match the `\bAPP_VERSION\b` regex the app-shared
  // membership guards scan raw source with; `__APP_VERSION__` has no word boundary, so it does not.
  var __APP_VERSION__: string | undefined;
}

export const getAppVersion = (): string => globalThis.__APP_VERSION__ ?? 'unknown';
